import type { SerpBannerConfig } from '../types';

const desktopTourHotConfig = {
    fixed: [
        { id: 'adfox', cardIndex: 4 },
    ],
    queue: [
        { id: 'assistantSales', priority: 1, repeatMode: 'repeat' },
        { id: 'buyNow',         priority: 2, repeatMode: 'repeat' },
        { id: 'catchPrice',     priority: 3, repeatMode: 'repeat' },
        { id: 'dreamTour',    priority: 4, repeatMode: 'repeat' },
        { id: 'tourIncludes', priority: 5, repeatMode: 'repeat' },
        { id: 'hacks8',       priority: 6, repeatMode: 'repeat' },
        { id: 'appPromo',     priority: 7, repeatMode: 'repeat' },
    ],
} as const satisfies SerpBannerConfig;

export default desktopTourHotConfig;
